import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";

export default function CheckboxExtended({
  name,
  label,
  value,
  onChange,
  color = "primary"
}) {
  const handleChange = event => {
    onChange(name, event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={handleChange}
          name={name}
          color={color}
        />
      }
      label={label}
    />
  );
}
